/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

export const getFeedbackQuestion = (name, value) => {
    const question = question_fields.find((item) => {
        return item.name === name;
    });
    question.guid = crypto.randomUUID();
    question.value = value;
    return question;
};

export const question_fields = [
    {
        "name": "feedback_approve",
        "key": "is_this_helpful_",
        "type": "question.yesNo",
        "prompt": "Is this Helpful?",
        "label": "Is this Helpful?",
        "valueLabel": "Yes",
    },
    {
        "name": "feedback_other_feedback",
        "key": "other_feedback",
        "type": "question.longAnswer",
        "prompt": "Other Feedback",
        "label": "Other Feedback",
    },
    {
        "name": "feedback_title",
        "key": "model_title",
        "type": "question.shortAnswer",
        "prompt": "Model Title",
        "label": "Model Title",
    },
    {
        "name": "feedback_url",
        "key": "feedback_url",
        "type": "question.websiteUrl",
        "prompt": "Webpage Canonical URL",
        "label": "Webpage Canonical URL",
    },
    {
        "name": "feedback_path",
        "key": "webpage_path",
        "type": "question.shortAnswer",
        "prompt": "Webpage Path",
        "label": "Webpage Path",
    },
    {
        "name": "feedback_webpage",
        "key": "webpage_guid",
        "type": "question.shortAnswer",
        "prompt": "Webpage GUID",
        "label": "Webpage GUID",
    },
    {
        "name": "feedback_model",
        "key": "model_guid",
        "type": "question.shortAnswer",
        "prompt": "Model GUID",
        "label": "Model GUID",
    }
];
